import { base_colorAlert } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_sm, font_xs } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.StreamMessageRenderer {
    .message-content {
      margin-bottom: ${spacing(4)};
    }

    .completion-section {
      margin-bottom: ${spacing(4)};
      display: flex;
      align-items: center;
      gap: ${spacing(2)};

      .timestamp {
        ${font_xs};
        color: var(--color-text-secondary, #697080);
      }
    }

    .error-section {
      margin-bottom: ${spacing(4)};
      padding: ${spacing(4)};
      background-color: ${base_colorAlert}1A; /* 10% opacity */
      border-radius: ${spacing(2)};
      color: ${base_colorAlert};

      .error-message {
        ${font_sm};
      }
    }
  }
`
